module.exports = __webpack_public_path__ + "img/bear.a9197cde.png";